import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const InfoItem = ({ icon, label }) => (
    <div className="text-muted small info-item">
        <FontAwesomeIcon
            icon={icon}
            size="xs"
        />
        {label}
    </div>
);